import React, { useCallback } from 'react';
import { Snackbar } from '@material-ui/core';
import { useAppContext } from '~/modules/App/AppContext';
import RepliconSlide from '~/modules/common/components/RepliconSlide';

const messagePosition = { vertical: 'bottom', horizontal: 'left' };

const ResourceRequestActionMessageSnackBar = () => {
  const {
    state: { resourceRequestButtonActionMessage },
    dispatch
  } = useAppContext();

  const hideMessage = useCallback(() => {
    dispatch({
      type: 'RESOURCE-REQUEST-DRAWER-BUTTON-ACTION',
      resourceRequestButtonActionMessage: null
    });
  }, [dispatch]);

  return (
    <Snackbar
      open={Boolean(resourceRequestButtonActionMessage)}
      autoHideDuration={5000}
      onClose={hideMessage}
      TransitionComponent={RepliconSlide}
      anchorOrigin={messagePosition}
      message={resourceRequestButtonActionMessage}
    />
  );
};

export default ResourceRequestActionMessageSnackBar;
